

import DriverTripPaymentV3 from "./DriverTripPaymentV3/DriverTripPaymentV3"
import DriverSalaryV3 from "./DriverSalaryV3/DriverSalaryV3"
import DriverAdvancePayV3 from "./DriverAdvancePayV3/DriverAdvancePayV3"
import { Route } from "react-router-dom/cjs/react-router-dom.min"


export const branchApiNm = {

  getJobOrderAllDetail: "/branch/getJobOrderAllDetail"
}
export const extraPageName = {
  DriverTripPayment: "ค่าเที่ยว พนักงานขับรถ",
  DriverSalary: "เงินเดือนพนักงานขับรถ",
  DriverAdvancePay: "เงินเบิกล่วงหน้า",
  DriverTripPaymentV3: "ค่าเที่ยว พขร.",
  DriverAdvancePayV3: "เงินเบิกล่วงหน้า",
  DriverSalaryV3: "เงินเดือน พขร.",}
export const extraPageMenu = [
  { page: "DriverTripPaymentV3", num: "8.1", menuName: extraPageName.DriverTripPaymentV3, prNum: 8, permission: "EXE;FIN"},
  { page: "DriverAdvancePayV3", num: "8.2", menuName: extraPageName.DriverAdvancePayV3, prNum: 8},
  { page: "DriverSalaryV3", num: "8.3", menuName: extraPageName.DriverSalaryV3, prNum: 8, permission: "EXE;FIN"},
  ]

export const extraRoute = (path)=> [
  <Route key={"DriverTripPaymentV3"} path={`${path}/DriverTripPaymentV3`} ><DriverTripPaymentV3 /> </Route>,
  <Route key={"DriverAdvancePayV3"} path={`${path}/DriverAdvancePayV3`} ><DriverAdvancePayV3 /> </Route>,
  <Route key={"DriverSalaryV3"} path={`${path}/DriverSalaryV3`} ><DriverSalaryV3 /> </Route>,

]

export const extraMainRoute = (path)=> []
